import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'

import CashdeskGeneral from "@/components/pages/cashdesk/CashdeskGeneral"
import CashdeskSettings from "@/components/pages/cashdesk/CashdeskSettings"

export default {

    path: '/cashdesk',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['cashdesk'], countries: ['RU'] },
    // component:() => import('../components/pages/cashdesk/CashdeskGeneral.vue'),
    component: CashdeskGeneral,
    children: [
        { path: '', redirect: '/cashdesk/settings' },
        {
            path: 'settings', name: "CashdeskSettings",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashdesk'] },
            // component: () => import('../components/pages/cashdesk/CashdeskSettings.vue')
            component: CashdeskSettings
        },
        {
            path: 'cheques', name: "CashdeskCheques",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashdesk'] },
            component: () => import('../components/pages/cashdesk/CashdeskCheques.vue')
        },
        {
            path: 'xreports', name: "CashdeskXReports",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashdesk'] },
            component: () => import('../components/pages/cashdesk/CashdeskXReports.vue')
        },
        {
            path: 'shifts', name: "CashdeskShifts",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashdesk'] },
            component: () => import('../components/pages/cashdesk/CashdeskShifts.vue')
        },
        {
            path: 'kkm/shifts', name: "CashdeskKKMShifts",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashdesk', 'kkm'] },
            component: () => import('../components/pages/cashdesk/kkm/CashdeskKKMShifts.vue')
        },
        {
            path: 'kkm/operations', name: "CashdeskKKMOperations",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashdesk', 'kkm'] },
            component: () => import('../components/pages/cashdesk/kkm/CashdeskKKMOperations.vue')
        },
        {
            path: 'kkm/reports', name: "CashdeskKKMReports",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashdesk', 'kkm'] },
            component: () => import('../components/pages/cashdesk/kkm/CashdeskKKMReports.vue')
        },
        {
            path: 'kkm/terminal', name: "CashdeskKKMTerminal",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['cashdesk', 'kkm'] },
            component: () => import('../components/pages/cashdesk/kkm/CashdeskKKMTerminal.vue')
        },
    ]
}
